import { State } from "@features/base/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  Notification,
  NotificationForm,
  NotificationResponse,
  getNotifications as getNotificationsApi,
} from "./api";

type NotificationsState = State<{
  notifications: Notification[] | null;
  page: number;
  count: number;
  totalCount: number;
}>;

const initialState: NotificationsState = {
  notifications: null,
  loading: false,
  error: null,
  page: 1,
  count: 0,
  totalCount: 0,
};

export const getNotifications = createAsyncThunk<
  NotificationResponse,
  { userId: string; data: NotificationForm }
>(
  "notifications/getNotifications",
  async ({ userId, data }, { rejectWithValue }) => {
    try {
      return await getNotificationsApi(userId, data);
    } catch (error) {
      console.error("Notifications failed:", error);
      return rejectWithValue(error);
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.notifications;
        state.page = action.payload.page;
        state.count = action.payload.count;
        state.totalCount = action.payload.total_count;
      })
      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default notificationsSlice.reducer;
